// import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
// import { Box, Grid } from '@mui/material';
// import AnnouncementList from './AnnouncementList';
// import AnnouncementForm from './AnnouncementForm';
// import { variants } from '../../../variants/variants';
// import { useDispatch, useSelector } from 'react-redux';
// import { selectDeviceType, setAnnouncementStatus } from '../../Auth/authSlice';
// import { AbilityContext, Can } from '../../../context/Ability';
// import { useAbility } from '@casl/react';
// import useDetectKeyboardOpen from 'use-detect-keyboard-open';

// const Announcements = () => {
//   const [editingAnnouncement, setEditingAnnouncement] = useState(null);
//   const [showScrollButton, setShowScrollButton] = useState(false);
//   const ability = useAbility(AbilityContext);
//   const dispatch = useDispatch();
//   const [inputHeight, setInputHeight] = useState(100);
//   const inputRef = useRef(null);
//   const [keyboardVisible, setKeyboardVisible] = useState(false);
//   const [showToolbar, setShowToolbar] = useState(false);
//   const isKeyboardOpen = useDetectKeyboardOpen();
//   const os = useSelector(selectDeviceType);
//   const [initialHeight, setInitialHeight] = useState(window.innerHeight);
//   const [keyboardHeight, setKeyboardHeight] = useState(0);
  
//   useEffect(() => {
//   const setVh = () => {
//     const vh = window.innerHeight * 0.01;
//     document.documentElement.style.setProperty('--vh', `${vh}px`);
//   };

//   setVh();
//   window.addEventListener('resize', setVh);

//   return () => {
//     window.removeEventListener('resize', setVh);
//   };
// }, []);


//   useEffect(() => {
//     const handleResize = () => {
//       const currentHeight = window.innerHeight;
//       const heightDiff = initialHeight - currentHeight;

//       if (heightDiff > 150) {
//         // Keyboard likely open
//         setKeyboardHeight(heightDiff);
//       } else {
//         // Keyboard likely closed
//         setKeyboardHeight(0);
//       }
//     };

//     window.addEventListener('resize', handleResize);

//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, [initialHeight]);

//   useEffect(() => {
//     setInitialHeight(window.innerHeight);
//   }, []);

//   const handleChange = (val) => {
//     setInputHeight(val);
//   };

//   useLayoutEffect(() => {
//     dispatch(setAnnouncementStatus(false));
//   }, [dispatch]);

//   useLayoutEffect(() => {
//     const handleResize = () => {
//       if (inputRef.current) {
//         setInputHeight(inputRef.current.clientHeight);
//       }
//     };

//     const handleFocus = () => {
//       setKeyboardVisible(true);
//       adjustBottomPosition();
//     };

//     const handleBlur = () => {
//       setKeyboardVisible(false);
//       adjustBottomPosition();
//     };

//     const adjustBottomPosition = () => {
//       if (inputRef.current) {
//         const bottomOffset = keyboardVisible && !showToolbar ? '80px' : '0px';
//         inputRef.current.style.bottom = bottomOffset;
//       }
//     };

//     window.addEventListener('resize', handleResize);

//     // Event listeners for focus and blur on the form control
//     if (inputRef.current) {
//       const formInputs = inputRef.current.querySelectorAll('input, textarea, select');
//       formInputs.forEach((input) => {
//         input.addEventListener('focus', handleFocus);
//         input.addEventListener('blur', handleBlur);
//       });
//     }

//     return () => {
//       window.removeEventListener('resize', handleResize);
//       if (inputRef.current) {
//         const formInputs = inputRef.current.querySelectorAll('input, textarea, select');
//         formInputs.forEach((input) => {
//           input.removeEventListener('focus', handleFocus);
//           input.removeEventListener('blur', handleBlur);
//         });
//       }
//     };
//   }, []);

//   useLayoutEffect(() => {
//     if (inputRef.current) {
//       const bottomOffset = '0px';
//       inputRef.current.style.bottom = bottomOffset;
//       setInputHeight(inputRef.current.clientHeight);
//     }
//   }, [showToolbar]);
//   return (
//     <Grid
//       container
//       sx={{
//         position: 'relative',
//         borderRadius: variants.boxRadius.NAVBAR,
//         background: 'white',
//         border: 1,
//         borderColor: 'divider',
//         display: 'flex',
//         flex: 1,
//         // height: isKeyboardOpen && os !== 'ios' ? `calc(var(--vh, 1vh) * 100)` : '100%',
//         height: isKeyboardOpen && os !== 'ios' ? `calc(100% - ${keyboardHeight}px)` : '100%',
//       }}
//     >
//       {ability.can('create', 'Announcement') ? (
//         <>
//           <Grid
//             item
//             xs={12}
//             sx={{
//               // position: 'relative',
//               overflow: 'auto',
//               paddingBottom: '0',
//               // height: `calc(90vh - ${inputHeight}px)`,
//               height: `90%`,
//               border: 0,
//             }}
//           >
//             <AnnouncementList
//               setEditingAnnouncement={setEditingAnnouncement}
//               showScrollButton={showScrollButton}
//               setShowScrollButton={setShowScrollButton}
//               inputHeight={inputHeight}
//             />
//           </Grid>
//           <Grid
//             item
//             xs={12}
//             sx={{
//               // position: 'absolute', bottom: 0, left: 0, right: 0,
//               height: `10%`,
              
//             }}
//           >
//             <AnnouncementForm
//               editingAnnouncement={editingAnnouncement}
//               setEditingAnnouncement={setEditingAnnouncement}
//               showScrollButton={showScrollButton}
//               onChange={handleChange}
//               inputRef={inputRef}
//               showToolbar={showToolbar}
//               setShowToolbar={setShowToolbar}
//             />
//           </Grid>
//         </>
//       ) : (
//         <Grid item xs={12} sx={{ overflow: 'auto', paddingBottom: '0', height: `calc(95vh - ${inputHeight}px)` }}>
//           <AnnouncementList
//             setEditingAnnouncement={setEditingAnnouncement}
//             showScrollButton={showScrollButton}
//             setShowScrollButton={setShowScrollButton}
//             inputHeight={inputHeight}
//           />
//         </Grid>
//       )}
//     </Grid>
//   );
// };

// export default Announcements;

// 2nd version by claude working in 2 device
import React, { useEffect, useLayoutEffect, useRef, useState, useCallback } from 'react';
import { Box, Grid } from '@mui/material';
import AnnouncementList from './AnnouncementList';
import AnnouncementForm from './AnnouncementForm';
import { variants } from '../../../variants/variants';
import { useDispatch, useSelector } from 'react-redux';
import { selectDeviceType, setAnnouncementStatus } from '../../Auth/authSlice';
import { AbilityContext, Can } from '../../../context/Ability';
import { useAbility } from '@casl/react';
import useDetectKeyboardOpen from 'use-detect-keyboard-open';

const Announcements = () => {
  const [editingAnnouncement, setEditingAnnouncement] = useState(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const ability = useAbility(AbilityContext);
  const dispatch = useDispatch();
  const [inputHeight, setInputHeight] = useState(100);
  const inputRef = useRef(null);
  const containerRef = useRef(null);
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [showToolbar, setShowToolbar] = useState(false);
  const isKeyboardOpen = useDetectKeyboardOpen();
  const os = useSelector(selectDeviceType);
  
  // Enhanced keyboard detection states
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [activeInput, setActiveInput] = useState(null);

  // Initialize viewport height and CSS custom properties
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };

    setVh();
    setViewportHeight(window.innerHeight);
    window.addEventListener('resize', setVh);

    return () => {
      window.removeEventListener('resize', setVh);
    };
  }, []);

  // Enhanced keyboard detection with better threshold handling
  useEffect(() => {
    let resizeTimer;
    
    const handleResize = () => {
      clearTimeout(resizeTimer);
      
      resizeTimer = setTimeout(() => {
        const currentHeight = window.innerHeight;
        const heightDiff = viewportHeight - currentHeight;
        
        // Different thresholds for different OS
        const threshold = os === 'ios' ? 100 : 150;
        
        if (heightDiff > threshold && isInputFocused) {
          // Keyboard is open
          setKeyboardHeight(heightDiff);
          setKeyboardVisible(true);
          
          // Scroll active input into view
          if (activeInput) {
            setTimeout(() => {
              activeInput.scrollIntoView({ 
                behavior: 'smooth', 
                block: 'center',
                inline: 'nearest'
              });
            }, 100);
          }
        } else if (heightDiff <= 50) {
          // Keyboard is closed
          setKeyboardHeight(0);
          setKeyboardVisible(false);
        }
      }, 100); // Debounce resize events
    };

    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(resizeTimer);
    };
  }, [viewportHeight, isInputFocused, activeInput, os]);

  // Handle input focus/blur events
  const handleInputFocus = useCallback((event) => {
    setIsInputFocused(true);
    setActiveInput(event.target);
    
    // For iOS, we might need to adjust immediately
    if (os === 'ios') {
      setTimeout(() => {
        event.target.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center'
        });
      }, 300);
    }
  }, [os]);

  const handleInputBlur = useCallback(() => {
    setIsInputFocused(false);
    setActiveInput(null);
    
    // Reset after a delay to allow for input switching
    setTimeout(() => {
      if (!document.activeElement || 
          !['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement.tagName)) {
        setKeyboardVisible(false);
        setKeyboardHeight(0);
      }
    }, 100);
  }, []);

  // Setup event listeners for all inputs
  useLayoutEffect(() => {
    const handleResize = () => {
      if (inputRef.current) {
        setInputHeight(inputRef.current.clientHeight);
      }
    };

    const setupInputListeners = () => {
      if (inputRef.current) {
        const formInputs = inputRef.current.querySelectorAll('input, textarea, select');
        formInputs.forEach((input) => {
          input.addEventListener('focus', handleInputFocus);
          input.addEventListener('blur', handleInputBlur);
        });
        
        return formInputs;
      }
      return [];
    };

    window.addEventListener('resize', handleResize);
    const inputs = setupInputListeners();

    return () => {
      window.removeEventListener('resize', handleResize);
      inputs.forEach((input) => {
        input.removeEventListener('focus', handleInputFocus);
        input.removeEventListener('blur', handleInputBlur);
      });
    };
  }, [handleInputFocus, handleInputBlur]);

  const handleChange = (val) => {
    setInputHeight(val);
  };

  useLayoutEffect(() => {
    dispatch(setAnnouncementStatus(false));
  }, [dispatch]);

  // Simple and reliable height calculations
  const getContainerHeight = () => {
    if (keyboardVisible && keyboardHeight > 0) {
      return `calc(100vh - ${keyboardHeight}px)`;
    }
    return '100%';
  };

  return (
    <Grid
      container
      ref={containerRef}
      sx={{
        position: 'relative',
        borderRadius: variants.boxRadius.NAVBAR,
        background: 'white',
        border: 1,
        borderColor: 'divider',
        display: 'flex',
        flex: 1,
        height: getContainerHeight(),
      }}
    >
      {ability.can('create', 'Announcement') ? (
        <>
          <Grid
            item
            xs={12}
            sx={{
              overflow: 'auto',
              paddingBottom: '0',
              height: '90%',
              border: 0,
            }}
          >
            <AnnouncementList
              setEditingAnnouncement={setEditingAnnouncement}
              showScrollButton={showScrollButton}
              setShowScrollButton={setShowScrollButton}
              inputHeight={inputHeight}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              height: '10%',
              minHeight: '60px',
            }}
          >
            <AnnouncementForm
              editingAnnouncement={editingAnnouncement}
              setEditingAnnouncement={setEditingAnnouncement}
              showScrollButton={showScrollButton}
              onChange={handleChange}
              inputRef={inputRef}
              showToolbar={showToolbar}
              setShowToolbar={setShowToolbar}
            />
          </Grid>
        </>
      ) : (
        <Grid 
          item 
          xs={12} 
          sx={{ 
            overflow: 'auto', 
            paddingBottom: '0', 
            height: `calc(100%)`,
            // height: `calc(100% - ${inputHeight}px)`,
          }}
        >
          <AnnouncementList
            setEditingAnnouncement={setEditingAnnouncement}
            showScrollButton={showScrollButton}
            setShowScrollButton={setShowScrollButton}
            inputHeight={inputHeight}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Announcements;

// 3rd version
// import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
// import { Box, Grid } from '@mui/material';
// import AnnouncementList from './AnnouncementList';
// import AnnouncementForm from './AnnouncementForm';
// import { variants } from '../../../variants/variants';
// import { useDispatch, useSelector } from 'react-redux';
// import { selectDeviceType, setAnnouncementStatus } from '../../Auth/authSlice';
// import { AbilityContext, Can } from '../../../context/Ability';
// import { useAbility } from '@casl/react';

// const Announcements = () => {
//   const [editingAnnouncement, setEditingAnnouncement] = useState(null);
//   const [showScrollButton, setShowScrollButton] = useState(false);
//   const [showToolbar, setShowToolbar] = useState(false);
//   const [inputHeight, setInputHeight] = useState(100);
  
//   const ability = useAbility(AbilityContext);
//   const dispatch = useDispatch();
//   const inputRef = useRef(null);
//   const containerRef = useRef(null);
//   const os = useSelector(selectDeviceType);
  
//   // Core keyboard detection states
//   const [initialViewportHeight] = useState(() => window.innerHeight);
//   const [currentViewportHeight, setCurrentViewportHeight] = useState(window.innerHeight);
//   const [keyboardHeight, setKeyboardHeight] = useState(0);
//   const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

//   // Set CSS custom properties for consistent viewport handling
//   useEffect(() => {
//     const updateViewportHeight = () => {
//       const vh = window.innerHeight * 0.01;
//       document.documentElement.style.setProperty('--vh', `${vh}px`);
//     };
    
//     updateViewportHeight();
//     window.addEventListener('resize', updateViewportHeight);
    
//     return () => window.removeEventListener('resize', updateViewportHeight);
//   }, []);

//   // Robust keyboard detection with proper thresholds
//   useEffect(() => {
//     let timeoutId;
    
//     const handleViewportChange = () => {
//       clearTimeout(timeoutId);
      
//       timeoutId = setTimeout(() => {
//         const newHeight = window.innerHeight;
//         const heightDifference = initialViewportHeight - newHeight;
        
//         // Dynamic threshold based on device type and screen size
//         const baseThreshold = Math.min(150, initialViewportHeight * 0.25);
//         const threshold = os === 'ios' ? baseThreshold * 0.8 : baseThreshold;
        
//         setCurrentViewportHeight(newHeight);
        
//         if (heightDifference > threshold) {
//           // Keyboard is open
//           setKeyboardHeight(heightDifference);
//           setIsKeyboardOpen(true);
//         } else {
//           // Keyboard is closed
//           setKeyboardHeight(0);
//           setIsKeyboardOpen(false);
//         }
//       }, 100);
//     };

//     window.addEventListener('resize', handleViewportChange);
    
//     return () => {
//       window.removeEventListener('resize', handleViewportChange);
//       clearTimeout(timeoutId);
//     };
//   }, [initialViewportHeight, os]);

//   // Handle input measurements
//   useLayoutEffect(() => {
//     const measureInput = () => {
//       if (inputRef.current) {
//         const height = inputRef.current.getBoundingClientRect().height;
//         setInputHeight(height || 100);
//       }
//     };

//     measureInput();
    
//     const resizeObserver = new ResizeObserver(measureInput);
//     if (inputRef.current) {
//       resizeObserver.observe(inputRef.current);
//     }

//     return () => resizeObserver.disconnect();
//   }, []);

//   // Scroll focused input into view when keyboard opens
//   useEffect(() => {
//     if (!isKeyboardOpen) return;

//     const handleFocusScroll = () => {
//       const activeElement = document.activeElement;
//       if (activeElement && ['INPUT', 'TEXTAREA', 'SELECT'].includes(activeElement.tagName)) {
//         setTimeout(() => {
//           activeElement.scrollIntoView({
//             behavior: 'smooth',
//             block: 'center',
//             inline: 'nearest'
//           });
//         }, 300);
//       }
//     };

//     document.addEventListener('focusin', handleFocusScroll);
//     return () => document.removeEventListener('focusin', handleFocusScroll);
//   }, [isKeyboardOpen]);

//   const handleChange = (val) => {
//     setInputHeight(val);
//   };

//   useLayoutEffect(() => {
//     dispatch(setAnnouncementStatus(false));
//   }, [dispatch]);

//   // Calculate container height with keyboard compensation
//   const containerHeight = isKeyboardOpen 
//     ? `calc(100vh - ${keyboardHeight}px)`
//     : '100vh';

//   // Calculate list height accounting for input form
//   const listHeight = ability.can('create', 'Announcement')
//     ? `calc(100% - ${inputHeight}px - 16px)` // 16px for padding
//     : '100%';

//   return (
//     <Box
//       ref={containerRef}
//       sx={{
//         height: containerHeight,
//         maxHeight: containerHeight,
//         width: '100%',
//         display: 'flex',
//         flexDirection: 'column',
//         position: 'relative',
//         borderRadius: variants.boxRadius.NAVBAR,
//         background: 'white',
//         border: 1,
//         borderColor: 'divider',
//         overflow: 'hidden',
//         transition: isKeyboardOpen ? 'none' : 'height 0.2s ease-out',
//       }}
//     >
//       {/* Messages List */}
//       <Box
//         sx={{
//           flex: 1,
//           overflow: 'auto',
//           height: listHeight,
//           minHeight: 0, // Important for flex child with overflow
//         }}
//       >
//         <AnnouncementList
//           setEditingAnnouncement={setEditingAnnouncement}
//           showScrollButton={showScrollButton}
//           setShowScrollButton={setShowScrollButton}
//           inputHeight={inputHeight}
//         />
//       </Box>

//       {/* Input Form - Only show if user can create announcements */}
//       {ability.can('create', 'Announcement') && (
//         <Box
//           ref={inputRef}
//           sx={{
//             flexShrink: 0,
//             backgroundColor: 'white',
//             borderTop: '1px solid',
//             borderTopColor: 'divider',
//             position: 'sticky',
//             bottom: 0,
//             zIndex: 1,
//           }}
//         >
//           <AnnouncementForm
//             editingAnnouncement={editingAnnouncement}
//             setEditingAnnouncement={setEditingAnnouncement}
//             showScrollButton={showScrollButton}
//             onChange={handleChange}
//             inputRef={inputRef}
//             showToolbar={showToolbar}
//             setShowToolbar={setShowToolbar}
//           />
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default Announcements;